import urlJoin from 'url-join';

const endpoints =
  MAPBOX_API_BASE && MAPBOX_ACCESS_TOKEN
    ? {
        'mapbox.places': urlJoin(MAPBOX_API_BASE, 'geocoding/v5/mapbox.places'),
        'mapbox.places-permanent': urlJoin(
          MAPBOX_API_BASE,
          'geocoding/v5/mapbox.places-permanent',
        ),
      }
    : null;

export default endpoints;
